import { IACHDisbursementFormData } from 'types/order/escrow/achDisbursements/IACHDisbursementFormData';
import { ICheckDisbursementFormData } from 'types/order/escrow/checks/ICheckDisbursementFormData';
import { IWireDisbursementFormData } from 'types/order/escrow/wires/IWireDisbursementFormData';
import { v4 } from 'uuid';
import { defaultCheckMemo } from '../defaultMemo';
import { IInternalTransferDisbursementFormData } from 'types/order/escrow/internalTransferDisbursements/IInternalTransferDisbursementFormData';
import { eDisbursementType } from 'types/order/escrow/eDisbursementType';
import { defaultCreate } from '../defaultCreate';
import { ICreateSettlementFeeForm } from 'types/order/fees/ICreateSettlementItemForm';
import { IOrderDetailsData } from '../../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export const CheckConversions = {
  ACH: (
    achData: IACHDisbursementFormData,
    order: IOrderDetailsData,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): ICheckDisbursementFormData => {
    const { amountCents, statementFeeId, holdback, holdbackProperties, account } = achData;
    const memo = defaultCheckMemo(order);
    return {
      type: eDisbursementType.Check,
      id: v4(),
      amountCents,
      memo,
      isNew: true,
      statementFeeId,
      name: account?.name,
      mailingAddress: { stateAbbreviation: '', streetAddress: '', city: '', zipCode: '' },
      holdback,
      holdbackProperties,
    };
  },
  'Internal Transfer': (
    internalTransfer: IInternalTransferDisbursementFormData,
    order: IOrderDetailsData,
    fee: ICreateSettlementFeeForm,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): ICheckDisbursementFormData => {
    const { amountCents, statementFeeId, holdback, holdbackProperties } = internalTransfer;
    const { beneficiary } = defaultCreate(fee, order, isSpruceWithZillowEnabled, isZillowClosing);
    const memo = defaultCheckMemo(order);
    return {
      type: eDisbursementType.Check,
      id: v4(),
      amountCents,
      memo,
      name: beneficiary,
      isNew: true,
      statementFeeId,
      mailingAddress: { stateAbbreviation: '', streetAddress: '', city: '', zipCode: '' },
      holdback,
      holdbackProperties,
    };
  },
  Wire: (
    wireData: IWireDisbursementFormData,
    order: IOrderDetailsData,
    fee: ICreateSettlementFeeForm,
    isSpruceWithZillowEnabled: boolean,
    isZillowClosing: boolean
  ): ICheckDisbursementFormData => {
    const { beneficiary, amountCents, statementFeeId, holdback, holdbackProperties } = wireData;
    const memo = defaultCheckMemo(order);
    return {
      type: eDisbursementType.Check,
      id: v4(),
      isNew: true,
      name: beneficiary ?? '',
      category: undefined,
      statementFeeId,
      amountCents,
      memo,
      mailingAddress: { stateAbbreviation: '', streetAddress: '', city: '', zipCode: '' },
      holdback,
      holdbackProperties,
    };
  },
};
